import LaptopImg from '@ui-components/neo.tax/dist/images/computer.png';
import React from 'react';

import { screenshots } from './screenshots';
import {
  StyledAuthorContainer,
  StyledAuthorInfo,
  StyledCompanyImage,
  StyledImageContainer,
  StyledLaptopImage,
  StyledName,
  StyledProfileImage,
  StyledQuote,
  StyledQuoteContainer,
  StyledScalableContainer,
  StyledScreenshotImage,
  StyledTestimonialContainer,
  StyledTestimonialRootContainer,
  StyledTextContainer,
  StyledTitleAndCompany,
} from './testimonial.styled';
import { testimonials } from './testimonials';

export const Testimonial = (): React.ReactElement => {
  const testimonialIndex = Math.floor(Math.random() * testimonials.length);
  const screenshotIndex = Math.floor(Math.random() * screenshots.length);
  const testimonial = testimonials[testimonialIndex];
  const screenshot = screenshots[screenshotIndex];

  return (
    <StyledTestimonialRootContainer>
      <StyledTestimonialContainer>
        <StyledCompanyImage src={testimonial.companyImage} alt={`${testimonial.name} company logo`} />
        <StyledQuoteContainer>
          <StyledScalableContainer height={testimonial.height} width={753}>
            <StyledTextContainer>
              <StyledQuote as="p" fontSize="2xl" fontFamily="serif" lineHeight={9}>
                &ldquo;{testimonial.quote}&rdquo;
              </StyledQuote>
              <StyledAuthorContainer>
                <StyledProfileImage src={testimonial.image} alt={testimonial.name} />
                <StyledAuthorInfo>
                  <StyledName as="p" fontSize="lg" fontWeight="medium" lineHeight={6}>
                    {testimonial.name}
                  </StyledName>
                  <StyledTitleAndCompany as="p" fontSize="base" fontWeight="normal" lineHeight={6}>
                    {testimonial.titleAndCompany}
                  </StyledTitleAndCompany>
                </StyledAuthorInfo>
              </StyledAuthorContainer>
            </StyledTextContainer>
          </StyledScalableContainer>
        </StyledQuoteContainer>
        <StyledImageContainer>
          <StyledLaptopImage src={LaptopImg} />
          <StyledScreenshotImage src={screenshot} />
        </StyledImageContainer>
      </StyledTestimonialContainer>
    </StyledTestimonialRootContainer>
  );
};

export const TestimonialMemo = React.memo(Testimonial);
